import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
/**
 * Compact mobile header shared by the BNPL form flows (Figma 253-78663),
 * matching the split-payment / amwal mobile header: light page-blue band,
 * centered bold title, back chevron on the leading edge.
 *
 * Both the back button and the title hide during the OTP step (chevron because
 * the sheet has its own dismiss, title collapses to a balancing spacer).
 */
var BNPLMobileFormHeader = function BNPLMobileFormHeader(_ref) {
  var title = _ref.title,
    hideBack = _ref.hideBack,
    isOtpStep = _ref.isOtpStep,
    onBack = _ref.onBack,
    action = _ref.action;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-[#F4F7FB] px-[5%] pb-2 pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center justify-between"
  }, !hideBack ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "back",
    className: "border-none bg-transparent",
    onClick: onBack
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--chevron-right-rounded",
    className: "en:rotate-180 text-primary-new",
    width: 7,
    height: 7
  })) : /*#__PURE__*/React.createElement("span", {
    className: "w-6"
  }), !isOtpStep ? /*#__PURE__*/React.createElement("strong", {
    className: "text-base font-bold leading-6 text-[#00143c]"
  }, title) : /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-8"
  }), action !== null && action !== void 0 ? action : /*#__PURE__*/React.createElement("div", null)));
};
export default BNPLMobileFormHeader;